import React, { Component } from 'react';
import axios from '../../axios';
import qs from 'qs';
import Alert from 'react-s-alert'
import FormDropdown from '../../components/FormDropdown'
import { status_aktif } from '../../constants/general'
import ModalHelp from "../../components/ModalHelp";

const maintenance = [
    { key: "1", value: "Aktif" },
    { key: "0", value: "Non Aktif" }
]

const time = [
    { key: "Asia/Jakarta", value: "WIB" },
    { key: "Asia/Makassar", value: "WITA" },
    { key: "Asia/Jayapura", value: "WIT" },
]

class Forms extends Component {
    constructor(props) {
        super(props)

        this.state = {
            app_version       : "",
            maintenance       : "",
            attendance              : "",
            pulang                  : "",
            admin_call                  : "",
            android_guru_app_version    : "",
            app_version_ios             : "",
            ios_guru_app_version        : "",
            school_name                 :"",
            timezone                 :"",
            tutorial: '',
            isModalHelpShow  : false,
            totmasuk                 :"",
            examout                 :"",
            isButtonLoading : false,
            isLoading       : false,
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.toggleModalHelp                = this.toggleModalHelp.bind(this)
    }
    toggleModalHelp() {

        this.setState({tutorial : 'https://www.youtube.com/embed/C5mOgsS1M0k'})

        this.setState({ isModalHelpShow: ! this.state.isModalHelpShow })
    }


    handleChange(event) {

        const target = event.target;
        const value  = target.type === 'checkbox' ? target.checked : target.value;
        const name   = target.name;

        this.setState({
            [name]: value
        })
    }

    handleSubmit() {

        this.setState({isButtonLoading: true})

        const url = this.props.mode === "Tambah" ? "setting/add" : "setting/edit"

        axios({
            method: 'post',
            url: url,
            data: qs.stringify(this.state)
        })
            .then(response => {

                const result = response.data;

                if (result.success) {

                    Alert.success(result.message)
                    window.location.reload()
                }
                else {

                    if (Array.isArray(result.message)) {

                        result.message.map(item => {
                            Alert.error(item)

                            return true
                        })
                    }
                    else {

                        Alert.error(result.message)
                    }

                    this.setState({ isButtonLoading: false })
                }
            })
            .catch(error => {

                console.log(error)
                this.setState({isButtonLoading: false})
                Alert.error("Gagal terhubung ke server!")
            })

    }

    loadData() {


        if (this.props.mode === "Edit") {

            this.setState({ isLoading: true })

            axios({
                method: 'post',
                url: '/setting'
            })
                .then(response => {

                    const result = response.data
                    if (result.success) {
                        this.setState({
                            app_version     : result.data[3].setting_value,
                            maintenance     : result.data[4].setting_value,
                            attendance      : result.data[6].setting_value,
                            pulang          : result.data[12].setting_value,
                            admin_call      : result.data[8].setting_value,
                            android_guru_app_version    : result.data[9].setting_value,
                            app_version_ios             : result.data[10].setting_value,
                            ios_guru_app_version        : result.data[11].setting_value,
                            totmasuk        : result.data[13].setting_value,
                            timezone        : result.data[14] ? result.data[14].setting_value : 'Asia/Jakarta',
                            examout        : result.data[15] ? result.data[15].setting_value : '5',

                        })
                    }
                    else {

                        Alert.error(result.message)
                    }

                    this.setState({ isLoading: false })
                })
                .catch((error) => {

                    console.log(error)
                    Alert.error("Gagal terhubung ke server!")
                    this.setState({ isLoading: false })
                })
        }

    }

    componentDidMount() {

		if(localStorage.SISMART_USER_LEVEL !=='administrator'){
			this.props.history.replace("/dashboard");
        }
        
        this.loadData()
    }

    render() {

        return (
            <div className="col-sm-12">
                <ModalHelp
                    isShow={this.state.isModalHelpShow}
                    toggleModal={this.toggleModalHelp}
                    handleSubmit={this.handleSubmitDeleteButton}
                    modalHeaderText="Tutorial Penggunaan Fitur"
                    modalBodyText={this.state.tutorial}
                    modalSubmitText="Ya" />
                <div className="card">
                    <div className="card-header">
                        {this.props.mode} Pengaturan
                        <button
                            type="button"
                            title='Tutorial'
                            className="btn btn-danger btn-sm"
                            style={{ float: 'right'}}
                            onClick={() => {
                                this.toggleModalHelp();
                                // this.setState({ tutorial: levelName});
                            }}
                        >
                            <i className="fa fa-question-circle"s></i>
                        </button>
                    </div>
                    <div className="card-block">
                        {
                            this.state.isLoading ? 'Memuat Data...' : (
                                <div className="form-horizontal animated fadeIn">

                                    <div className="form-group row">
                                        <label className="col-md-2 form-control-label">Siswa Wali Version</label>
                                        <div className="col-md-4">
                                            <input
                                                name="app_version"
                                                type="text"
                                                className="form-control"
                                                placeholder="Siswa Wali Version"
                                                onChange={this.handleChange}
                                                value={this.state.app_version} />
                                        </div>
                                    </div>
                                    {

                                        localStorage.SISMART_USER_USERNAME !== 'root@master.com' ? (
                                            " "
                                        ) : (

                                            <div className="form-group row">
                                                <label className="col-md-2 form-control-label">App Maintenance</label>
                                                <div className="col-md-4">
                                                    <FormDropdown
                                                        items={maintenance}
                                                        onChange={this.handleChange}
                                                        value={this.state.maintenance}
                                                        name="maintenance"
                                                    />
                                                </div>
                                            </div>

                                        )

                                    }

                                    <div className="form-group row">
                                        <label className="col-md-2 form-control-label">TimeZone</label>
                                        <div className="col-md-4">
                                            <FormDropdown
                                                items={time}
                                                onChange={this.handleChange}
                                                value={this.state.timezone}
                                                name="timezone"
                                            />
                                        </div>
                                    </div>

                                    {/*<div className="form-group row">*/}
                                    {/*    <label className="col-md-2 form-control-label">Jam Masuk Sekolah</label>*/}
                                    {/*    <div className="col-md-4">*/}
                                    {/*        <input*/}
                                    {/*            name="attendance"*/}
                                    {/*            type="text"*/}
                                    {/*            className="form-control"*/}
                                    {/*            placeholder="Jam Masuk Sekolah"*/}
                                    {/*            onChange={this.handleChange}*/}
                                    {/*            value={this.state.attendance} />*/}
                                    {/*    </div>*/}
                                    {/*</div>*/}
                                    {/*<div className="form-group row">*/}
                                    {/*    <label className="col-md-2 form-control-label">Jam Pulang Sekolah</label>*/}
                                    {/*    <div className="col-md-4">*/}
                                    {/*        <input*/}
                                    {/*            name="pulang"*/}
                                    {/*            type="text"*/}
                                    {/*            className="form-control"*/}
                                    {/*            placeholder="Jam Masuk Sekolah"*/}
                                    {/*            onChange={this.handleChange}*/}
                                    {/*            value={this.state.pulang} />*/}
                                    {/*    </div>*/}
                                    {/*</div>*/}
                                    <div className="form-group row">
                                        <label className="col-md-2 form-control-label">Hp Admin</label>
                                        <div className="col-md-4">
                                            <input
                                                name="admin_call"
                                                type="text"
                                                className="form-control"
                                                placeholder="Hp Admin"
                                                onChange={this.handleChange}
                                                value={this.state.admin_call} />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-md-2 form-control-label">Android Guru Version</label>
                                        <div className="col-md-4">
                                            <input
                                                name="android_guru_app_version"
                                                type="text"
                                                className="form-control"
                                                placeholder="Android Guru Version"
                                                onChange={this.handleChange}
                                                value={this.state.android_guru_app_version} />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-md-2 form-control-label">Siswa Wali Ios Version</label>
                                        <div className="col-md-4">
                                            <input
                                                name="app_version_ios"
                                                type="text"
                                                className="form-control"
                                                placeholder="Siswa Wali Ios Version"
                                                onChange={this.handleChange}
                                                value={this.state.app_version_ios} />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-md-2 form-control-label">Guru Ios Version</label>
                                        <div className="col-md-4">
                                            <input
                                                name="ios_guru_app_version"
                                                type="text"
                                                className="form-control"
                                                placeholder="Guru Ios Version"
                                                onChange={this.handleChange}
                                                value={this.state.ios_guru_app_version} />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-md-2 form-control-label">Total Masuk Sekolah</label>
                                        <div className="col-md-4">
                                            <input
                                                name="totmasuk"
                                                type="text"
                                                className="form-control"
                                                placeholder="*Jumlah hari Masuk sekolah"
                                                onChange={this.handleChange}
                                                value={this.state.totmasuk} />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-md-2 form-control-label">Max Keluar Ujian</label>
                                        <div className="col-md-4">
                                            <input
                                                name="examout"
                                                type="text"
                                                className="form-control"
                                                placeholder="*Batas keluar ujian"
                                                onChange={this.handleChange}
                                                value={this.state.examout} />
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                    <div className="card-footer">
                        <button
                            type="button"
                            className="btn btn-md btn-primary"
                            disabled={this.state.isButtonLoading && "disabled"}
                            onClick={this.handleSubmit}
                        >
                            {this.state.isButtonLoading ? "Loading" : "Simpan"}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default Forms;


// WEBPACK FOOTER //
// ./src/views/Setting/Forms.js